//NOTE: needs a relative parent componet
import React from 'react';
import styled from 'styled-components';
import {
  Container as LoaderContainer,
  Bars as LoaderBars,
  Bar as LoaderBar,
  Text as LoaderText,
} from '@rsos/components/capstone/Loader/Loader';
import { Box, Absolute } from '@rsos/components/capstone/base';

export const LoaderWrapper = styled(Box).attrs({
  bg: '#00000080',
  height: '100%',
  justify: 'center',
  align: 'center',
})``;

const BuildInLoaderBar = styled(LoaderBar)`
  background-color: '#FFF';
`;
const BuildInLoaderText = styled(LoaderText)`
  color: '#FFF';
`;
export const BuildInLoader = ({ text }) => (
  <LoaderContainer>
    <LoaderBars>
      <BuildInLoaderBar />
      <BuildInLoaderBar />
      <BuildInLoaderBar />
      <BuildInLoaderBar />
      <BuildInLoaderBar />
    </LoaderBars>
    <BuildInLoaderText>{text}</BuildInLoaderText>
  </LoaderContainer>
);
export const BuildInLoaderOverlay = ({ text = 'Loading...' }) => {
  return (
    <Absolute bottom={0} top={0} left={0} right={0}>
      <LoaderWrapper>
        <BuildInLoader text={text} />
      </LoaderWrapper>
    </Absolute>
  );
};
export default BuildInLoaderOverlay;
